import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmissionComponent } from '../../emission/emission.component';

@Component({
    selector: 'app-titres-primary',
    imports: [
        CommonModule,
        EmissionComponent
    ],
    templateUrl: './titres-primary.component.html',
    styleUrl: './titres-primary.component.scss'
})
export class TitresPrimaryComponent {

}
